<div [class.dark]="switcherStyle === 'dark'" [class.round]="round">
  <div class="switcher" (click)="toggle()">
    @for (tpl of templates; track tpl; let i = $index) {
      <div class="switcher-item" [class.selected]="isSelected(i)" (click)="select(i)">
        <ng-container [ngTemplateOutlet]="tpl"></ng-container>
      </div>
    }
  </div>
</div>
